import React from "react";
import { Edit, SimpleForm, DisabledInput, TextInput, DateInput, BooleanInput, LongTextInput } from "react-admin";
import { isAdmin } from "../../services/LocalStorage";

export const CampaignEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <DisabledInput source="id" label="ID"/>
      {isAdmin() && <TextInput source="coreShopId" label="Core shop ID"/>}
      <TextInput source="title" label="title"/>
      <BooleanInput source="active"/>
      <TextInput source="defaultCouponCode" label="Default coupon code"/>
      <LongTextInput source="defaultCouponDescription" label="Default coupon description"/>
      <DateInput source="startDate" label="startDate"/>
      <DateInput source="endDate" label="endDate"/>
      <BooleanInput source="randomCoupons"/>
      <BooleanInput source="reuseCoupons"/>
    </SimpleForm>
  </Edit>
);
